import { render, staticRenderFns } from "./Skyway.vue?vue&type=template&id=713a8ca1&"
import script from "./Skyway.vue?vue&type=script&lang=js&"
export * from "./Skyway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports